import {IRouletteBet} from "./IRouletteBet";

export class SplitBet implements IRouletteBet {
    constructor(public index: number, public betAmount: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/betTypes/SplitBet.ts